import React from "react";

const PauseIcon = ({className, fill = "#919EB0"}) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="18.286" height="24" viewBox="0 0 18.286 24" fill="currentColor">
        <path id="Pause_Icon" data-name="Pause Icon" d="M10,31.5h4.571V7.5H10Zm13.714-24v24h4.571V7.5Z" transform="translate(-10 -7.5)" />
    </svg>
);

export default PauseIcon;
